(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire07df"];
var parcelRegister = parcelRequire.register;
parcelRegister("1JSyC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $585d109b9a4d6c67$export$2e2bcd8739ae039; });

var $2hYdk = parcelRequire("2hYdk");

var $kDidw = parcelRequire("kDidw");

var $ayme0 = parcelRequire("ayme0");

var $eU8cG = parcelRequire("eU8cG");

var $gI1kx = parcelRequire("gI1kx");
// TODO: Use dataLayerSource?
// TODO: Don't use 'key' for storage, use HOC extension
const $585d109b9a4d6c67$var$magentoDataSource = ()=>{
    if (window.location.href.includes("/thank-you")) {
        const elements = [
            ".flex.flex-col.lg\\:flex-row.lg\\:space-x-8"
        ]; // Waits for inner div to load (it loads the purchase data)
        (0, $gI1kx.pollForElement)(elements, ()=>{
            // isTrackerLoaded(() => {
            window.dataLayer = window.dataLayer || [];
            for(let i = 0; i < window.dataLayer.length; i++){
                const data = window.dataLayer[i];
                if (data.event === "purchase") {
                    const ecommerce = data.ecommerce;
                    (0, $kDidw.isTrackerLoaded)(()=>{
                        (0, $ayme0.runOncePerPageLoad)(()=>{
                            (0, $2hYdk.default).notify({
                                transactionEvent: {
                                    id: ecommerce.transaction_id.toString(),
                                    total: parseFloat(ecommerce.value),
                                    tax: parseFloat(ecommerce.tax) || 0,
                                    shipping: parseFloat(ecommerce.shipping) || 0,
                                    city: "N/A",
                                    country: "USA",
                                    currency: "USD",
                                    couponCode: ecommerce.coupon || "N/A",
                                    discount: parseFloat(ecommerce.discount) || 0,
                                    state: "N/A",
                                    items: ecommerce.items.map((item)=>{
                                        return {
                                            orderId: ecommerce.transaction_id.toString(),
                                            sku: item.item_id.toString(),
                                            name: (item.item_name || "N/A").toString(),
                                            category: (item.item_category || "N/A").toString(),
                                            unitPrice: parseFloat(item.price || 0),
                                            quantity: parseInt(item.quantity || 1),
                                            currency: "USD"
                                        };
                                    })
                                }
                            });
                            sessionStorage.setItem("key", "loaded");
                        });
                    });
                }
            }
        // datalayerSource((data: any): void => {
        //   if (data.event === "purchase") {
        //     const ecommerce = data.ecommerce;
        //     observable.notify({
        //       transactionEvent: {
        //         id: ecommerce.transaction_id.toString(),
        //         total: parseFloat(ecommerce.value),
        //         tax: parseFloat(ecommerce.tax) || 0,
        //         shipping: parseFloat(ecommerce.shipping) || 0,
        //         city: "N/A",
        //         country: "USA",
        //         currency: "USD",
        //         state: "N/A",
        //         items: ecommerce.items.map((item: any) => {
        //           return {
        //             orderId: ecommerce.transaction_id.toString(),
        //             sku: item.item_id.toString(),
        //             name: (item.item_name || "N/A").toString(),
        //             category: (item.item_category || "N/A").toString(),
        //             unitPrice: parseFloat(item.price || 0),
        //             quantity: parseInt(item.quantity || 1),
        //             currency: "USD",
        //           } as TransactionCartItem;
        //         }),
        //       },
        //     });
        //     sessionStorage.setItem("key", "loaded");
        //   }
        // });
        // });
        });
    }
    if (!sessionStorage.getItem("key")) {
        window.dataLayer = window.dataLayer || [];
        for(let i = 0; i < window.dataLayer.length; i++){
            const data = window.dataLayer[i];
            if (data.event === "purchase") {
                const ecommerce = data.ecommerce;
                (0, $kDidw.isTrackerLoaded)(()=>{
                    (0, $ayme0.runOncePerPageLoad)(()=>{
                        (0, $2hYdk.default).notify({
                            transactionEvent: {
                                id: ecommerce.transaction_id.toString(),
                                total: parseFloat(ecommerce.value),
                                tax: parseFloat(ecommerce.tax) || 0,
                                shipping: parseFloat(ecommerce.shipping) || 0,
                                city: "N/A",
                                country: "USA",
                                currency: "USD",
                                state: "N/A",
                                items: ecommerce.items.map((item)=>{
                                    return {
                                        orderId: ecommerce.transaction_id.toString(),
                                        sku: item.id.toString(),
                                        name: (item.name || "N/A").toString(),
                                        category: (item.category || "N/A").toString(),
                                        unitPrice: parseFloat(item.price || 0),
                                        quantity: parseInt(item.quantity || 1),
                                        currency: "USD"
                                    };
                                })
                            }
                        });
                        sessionStorage.setItem("key", "loaded");
                    });
                });
            }
        }
    }
    (0, $eU8cG.xhrResponseSource)((xhr)=>{
        try {
            const getData = JSON.parse(xhr.responseText);
            const products = getData && getData.items;
            if (products !== undefined || products.length !== 0) {
                const dataToJSON = JSON.stringify(getData);
                sessionStorage.setItem("pixelData", dataToJSON);
            }
        } catch (e) {}
    });
    if (window.location.pathname.includes("/checkout/onepage/success/") || window.location.pathname.includes("/success/")) setTimeout(()=>{
        try {
            const storedData = sessionStorage.getItem("pixelData");
            const retrievedObject = JSON.parse(storedData);
            const productsList = retrievedObject && retrievedObject.items;
            const checkoutSuccessElement = document.querySelector(".checkout-success");
            const orderNumberElement = checkoutSuccessElement.querySelector("span");
            const orderNumber = orderNumberElement.textContent.trim();
            (0, $2hYdk.default).notify({
                transactionEvent: {
                    id: orderNumber,
                    total: parseFloat(retrievedObject.base_grand_total),
                    tax: parseFloat(retrievedObject.base_tax_amount) || 0,
                    shipping: parseFloat(retrievedObject.base_shipping_amount) || 0,
                    city: "N/A",
                    state: "N/A",
                    country: "N/A",
                    currency: "USD",
                    items: productsList.map((product)=>{
                        const { item_id: item_id, name: name, price: price, qty: qty } = product;
                        return {
                            orderId: orderNumber.toString(),
                            productId: item_id.toString(),
                            sku: item_id.toString(),
                            name: (name || "N/A").toString(),
                            category: "N/A",
                            unitPrice: parseFloat(price || 0),
                            quantity: parseInt(qty || 1),
                            currency: "USD"
                        };
                    })
                }
            });
        } catch (error) {
        // window.tracker("trackError", JSON.stringify(error), "MAGENTO");
        }
        sessionStorage.setItem("pixelData", "0");
    }, 1000);
};
var $585d109b9a4d6c67$export$2e2bcd8739ae039 = $585d109b9a4d6c67$var$magentoDataSource;

});
parcelRegister("kDidw", function(module, exports) {

$parcel$export(module.exports, "isTrackerLoaded", function () { return $d28923ed48da6cba$export$ab4cf8abbc961f2a; });
const $d28923ed48da6cba$export$ab4cf8abbc961f2a = (callback)=>{
    if (window.tracker) callback();
    else {
        let trackerLoaded = false;
        const intervalId = setInterval(()=>{
            if (window.tracker && !trackerLoaded) {
                trackerLoaded = true;
                clearInterval(intervalId);
                callback();
            }
        }, 100);
    }
};

});

parcelRegister("ayme0", function(module, exports) {

$parcel$export(module.exports, "runOncePerPageLoad", function () { return $75e8097ffc9f48ee$export$d3ea25cf7c7cc463; });
/*
 *   Saves a key on the session storage to indicate that the tracker has been
 *   loaded once, this will prevent multiple triggering of the code
 *   even without reloading the page. And when the user reloads the page,
 *   the key will be removed and placed again.
 */ 
var $lwczO = parcelRequire("lwczO");
const $75e8097ffc9f48ee$export$d3ea25cf7c7cc463 = (callback)=>{
    const key = "key";
    if (!sessionStorage.getItem(key)) {
        (0, $lwczO.default).info("First run in this session");
        callback();
        sessionStorage.setItem(key, "loaded");
    } else (0, $lwczO.default).info("Already run in this session");
    // Listen for the unload event to reset the sessionStorage item
    window.addEventListener("beforeunload", ()=>{
        sessionStorage.removeItem("key");
    });
    // Listen for page changes to reset the sessionStorage item
    window.addEventListener("popstate", ()=>{
        sessionStorage.removeItem("key");
    });
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;
    history.pushState = function(...args) {
        originalPushState.apply(this, args);
        sessionStorage.removeItem("key");
        window.dispatchEvent(new Event("popstate"));
    };
    history.replaceState = function(...args) {
        originalReplaceState.apply(this, args);
        sessionStorage.removeItem("key");
        window.dispatchEvent(new Event("popstate"));
    };
};

});


})();
//# sourceMappingURL=magento.83ff86da.js.map
